/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColDef } from 'ag-grid-enterprise';
import {
  FOUR_DIGIT_WIDTH,
  numberAsStringComparator,
  THREE_DIGIT_WIDTH,
  TWO_DIGIT_WIDTH,
} from 'components/common/Tables/CommonGridFormatters';

export enum OwnerPointsTableColId {
  Rank = 'rank',
  VehicleNumber = 'vehicleNumber',
  OwnerName = 'ownerName',
  OwnerFirstName = 'ownerFirstName',
  OwnerLastName = 'ownerLastName',
  Points = 'points',
  BonusPoints = 'bonusPoints',
  Starts = 'starts',
  Poles = 'poles',
  Wins = 'wins',
  Top5s = 'top5',
  Top10s = 'top10',
  DNFs = 'dnf',
}

export const ownerPointsTableColDefs: ColDef[] = [
  {
    colId: OwnerPointsTableColId.Rank,
    headerName: 'Rank',
    headerTooltip: 'Ranking of Owner Points Earned',
    width: 80,
    minWidth: TWO_DIGIT_WIDTH,
    type: 'rightAligned',
  },
  {
    colId: OwnerPointsTableColId.VehicleNumber,
    headerName: 'Vehicle',
    headerTooltip: 'Vehicle Number',
    width: 80,
    minWidth: TWO_DIGIT_WIDTH,
    type: 'rightAligned',
    comparator: numberAsStringComparator,
  },
  {
    colId: OwnerPointsTableColId.OwnerName,
    headerName: 'Owner',
    headerTooltip: 'Owner Name',
    flex: 1,
    minWidth: 160,
    type: 'rightAligned',
  },
  {
    colId: OwnerPointsTableColId.OwnerFirstName,
    headerName: 'First Name',
    headerTooltip: 'Owner First Name',
    width: 87,
    minWidth: 20,
    type: 'rightAligned',
  },
  {
    colId: OwnerPointsTableColId.OwnerLastName,
    headerName: 'Last Name',
    headerTooltip: 'Owner Last Name',
    width: 86,
    minWidth: 50,
    type: 'rightAligned',
  },
  {
    colId: OwnerPointsTableColId.Points,
    headerName: 'Points',
    headerTooltip: 'Points Earned',
    type: 'numericColumn',
    width: 80,
    minWidth: FOUR_DIGIT_WIDTH,
    sort: 'desc',
  },
  {
    colId: OwnerPointsTableColId.BonusPoints,
    headerName: 'Bonus',
    headerTooltip: 'Bonus Points Earned',
    type: 'numericColumn',
    width: 58,
    minWidth: THREE_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.Starts,
    headerName: 'Starts',
    headerTooltip: 'Number of Starts',
    type: 'numericColumn',
    width: 56,
    minWidth: THREE_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.Poles,
    headerName: 'Poles',
    headerTooltip: 'Number of Pole Starts',
    type: 'numericColumn',
    width: 54,
    minWidth: TWO_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.Wins,
    headerName: 'Wins',
    headerTooltip: 'Number of Wins',
    type: 'numericColumn',
    width: 49,
    minWidth: TWO_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.Top5s,
    headerName: 'Top 5s',
    headerTooltip: 'Number of Top 5 Finishes',
    type: 'numericColumn',
    width: 60,
    minWidth: TWO_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.Top10s,
    headerName: 'Top 10s',
    headerTooltip: 'Number of Top 10 Finishes',
    type: 'numericColumn',
    width: 68,
    minWidth: TWO_DIGIT_WIDTH,
  },
  {
    colId: OwnerPointsTableColId.DNFs,
    headerName: 'DNFs',
    headerTooltip: 'Number of DNFs',
    type: 'numericColumn',
    width: 52,
    minWidth: TWO_DIGIT_WIDTH,
  },
];
